import { useState } from "react";
import { resolveAssetPath } from "../../shared/utilities/assets";
import type { WeddingData } from "../../types/wedding";

interface Props {
  gifts: WeddingData["gifts"];
  open: boolean;
  copy: Record<string, string>;
  onClose: () => void;
}

export function GiftModal({ gifts, open, copy, onClose }: Props) {
  const [copied, setCopied] = useState("");
  if (!open || !gifts.enabled) return null;
  const accounts = gifts.bankAccounts.filter((bank) => bank.enabled).sort((a, b) => a.order - b.order);
  return (
    <div className="gift-modal is-visible" role="dialog" aria-modal="true" aria-labelledby="gift-title">
      <div className="gift-page">
        <button className="close-lightbox" type="button" onClick={onClose}>{copy.close}</button>
        <p className="eyebrow">Wedding Gift</p>
        <h2 id="gift-title">{copy.sendGift}</h2>
        <p>{copy.giftHelp}</p>
        <div className="bank-list">
          {accounts.map((bank) => (
            <article className="bank-card" key={bank.id}>
              {bank.bankLogo ? <img className="bank-logo-img" src={resolveAssetPath(bank.bankLogo)} alt={bank.bankName} /> : <strong>{bank.bankName}</strong>}
              <h3>{bank.accountNumber}</h3>
              <span>{bank.accountHolder}</span>
              <button
                className="copy-btn"
                type="button"
                onClick={async () => {
                  try { await navigator.clipboard.writeText(bank.accountNumber); } catch { /* local preview fallback */ }
                  setCopied(bank.id);
                }}
              >
                {copied === bank.id ? "Copied" : copy.copyNumber}
              </button>
            </article>
          ))}
          {!accounts.length ? <p>No bank account is enabled.</p> : null}
        </div>
      </div>
    </div>
  );
}
